import { ComparisonRuleType, ValidationParams, ValidationSubjectType } from "@/types/validationTypes";

export class Validation {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  ruleType: ComparisonRuleType;
  subjectId: string;
  failMessage?: string;
  passMessage: string;
  subjectType: ValidationSubjectType;
  script: string;
  title: string;

  constructor(params: ValidationParams) {
    this.id = params.id;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.ruleType = params.ruleType;
    this.subjectId = params.subjectId;
    this.failMessage = params.failMessage;
    this.passMessage = params.passMessage || '';
    this.subjectType = params.subjectType;
    this.script = params.script || '';
    this.title = params.title || '';
  }
}
